webpackJsonp([1],{

/***/ "/o2/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"persistent":"","width":"50%"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Inloggen")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Email","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Password","type":"password","required":""},model:{value:(_vm.paswoord),callback:function ($$v) {_vm.paswoord=$$v},expression:"paswoord"}})],1)],1)],1),_vm._v(" "),_c('small',[_vm._v("*indicates required field")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Annuleer")]),_vm._v(" "),_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":""},nativeOn:{"click":function($event){return _vm.Inloggen($event)}}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","width":"50%"},model:{value:(_vm.toonPlanVenster),callback:function ($$v) {_vm.toonPlanVenster=$$v},expression:"toonPlanVenster"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.dagZin)+"   ("+_vm._s(_vm.klas)+")")])]),_vm._v(" "),_c('v-card-text',[_c('v-form',[_c('v-text-field',{staticClass:"groot",attrs:{"append-icon":"assignment","label":"Taken"},model:{value:(_vm.actieveTaak),callback:function ($$v) {_vm.actieveTaak=$$v},expression:"actieveTaak"}}),_vm._v(" "),_c('v-text-field',{staticClass:"groot",attrs:{"append-icon":"feedback","label":"Lessen"},model:{value:(_vm.actieveLes),callback:function ($$v) {_vm.actieveLes=$$v},expression:"actieveLes"}}),_vm._v(" "),_c('v-text-field',{staticClass:"groot",attrs:{"append-icon":"date_range","label":"Planning"},model:{value:(_vm.actievePlanning),callback:function ($$v) {_vm.actievePlanning=$$v},expression:"actievePlanning"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":""},nativeOn:{"click":function($event){return _vm.AnnuleerInvoer($event)}}},[_vm._v("Annuleer")]),_vm._v(" "),_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":""},nativeOn:{"click":function($event){return _vm.SlaDagOp($event)}}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('table',[_c('tr',[_c('td',[_c('dagschema',{attrs:{"extradagen":"0","week":_vm.week}})],1),_vm._v(" "),_c('td',[_c('dagschema',{attrs:{"extradagen":"0","week":_vm.week+1,"isRegistered":_vm.registered}})],1),_vm._v(" "),_c('td',[_c('dagschema',{attrs:{"extradagen":"0","week":_vm.week+2}})],1)]),_vm._v(" "),_c('tr',[_c('td',[_c('dagschema',{attrs:{"extradagen":"1","week":_vm.week}})],1),_vm._v(" "),_c('td',[_c('dagschema',{attrs:{"extradagen":"1","week":_vm.week+1}})],1),_vm._v(" "),_c('td',[_c('dagschema',{attrs:{"extradagen":"1","week":_vm.week+2}})],1)]),_vm._v(" "),_c('tr',[_c('td',[_c('dagschema',{attrs:{"extradagen":"2","week":_vm.week}})],1),_vm._v(" "),_c('td',[_c('dagschema',{attrs:{"extradagen":"2","week":_vm.week+1}})],1),_vm._v(" "),_c('td',[_c('dagschema',{attrs:{"extradagen":"2","week":_vm.week+2}})],1)]),_vm._v(" "),_c('tr',[_c('td',[_c('dagschema',{attrs:{"extradagen":"3","week":_vm.week}})],1),_vm._v(" "),_c('td',[_c('dagschema',{attrs:{"extradagen":"3","week":_vm.week+1}})],1),_vm._v(" "),_c('td',[_c('dagschema',{attrs:{"extradagen":"3","week":_vm.week+2}})],1)]),_vm._v(" "),_c('tr',[_c('td',[_c('dagschema',{attrs:{"extradagen":"4","week":_vm.week}})],1),_vm._v(" "),_c('td',[_c('dagschema',{attrs:{"extradagen":"4","week":_vm.week+1}})],1),_vm._v(" "),_c('td',[_c('dagschema',{attrs:{"extradagen":"4","week":_vm.week+2}})],1)])]),_vm._v(" "),_c('v-btn',{staticClass:"pink",attrs:{"fixed":"","dark":"","fab":"","bottom":"","right":""},on:{"click":_vm.weekbij}},[_c('v-icon',[_vm._v("keyboard_arrow_right")])],1),_vm._v(" "),_c('v-btn',{staticClass:"pink",attrs:{"fixed":"","dark":"","fab":"","bottom":"","left":""},on:{"click":_vm.weekweg}},[_c('v-icon',[_vm._v("keyboard_arrow_left")])],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{staticClass:"red",attrs:{"fixed":"","dark":"","fab":"","bottom":""},on:{"click":_vm.laadGegevens}},[_vm._v("\n     "+_vm._s(_vm.klas)+"\n    ")]),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(!_vm.registered),expression:"!registered"}],staticClass:"ml-5",attrs:{"primary":"","dark":""},on:{"click":_vm.toonVenster}},[_vm._v("Log in")]),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.registered),expression:"registered"}],staticClass:"ml-5",attrs:{"primary":"","dark":""},on:{"click":_vm.Uitloggen}},[_vm._v("Uitloggen")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DRUu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"light":""}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F0o+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46acd8cb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("DRUu");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46acd8cb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stylus_main_styl__ = __webpack_require__("tLfa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stylus_main_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__stylus_main_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_store__ = __webpack_require__("wtEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__("YaEn");







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */]);
  },
  store: __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* store */],
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_4_firebase__["initializeApp"]({
      apiKey: "AIzaSyCTyDUcM6MxCnyFRzfUNXi8ee8GQQVcxbM",
      authDomain: "driewekenplanning.firebaseapp.com",
      databaseURL: "https://driewekenplanning.firebaseio.com",
      projectId: "driewekenplanning",
      storageBucket: "driewekenplanning.appspot.com"
    });
  }
});
'filehash iJz3DSJXowZgIDrPyBAjybjwqZU=';

/***/ }),

/***/ "OYhw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dagschema",on:{"click":_vm.toonDialoog}},[_c('v-toolbar-title',{staticClass:"deep-purple lighten-2 white--text body-2 c"},[_vm._v(_vm._s(_vm.dag))]),_vm._v(" "),_c('v-card',[_c('h5',[_c('v-icon',[_vm._v("assignment")]),_vm._v(_vm._s(_vm.huidigAgendaPunt.taak))],1),_vm._v(" "),_c('h5',[_c('v-icon',[_vm._v("feedback")]),_vm._v(_vm._s(_vm.huidigAgendaPunt.les))],1),_vm._v(" "),_c('h5',[_c('v-icon',[_vm._v("date_range")]),_vm._v(_vm._s(_vm.huidigAgendaPunt.planning))],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PlO8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dagschema_vue__ = __webpack_require__("w+xg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68f9d87a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dagschema_vue__ = __webpack_require__("OYhw");
function injectStyle (ssrContext) {
  __webpack_require__("ZfeE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dagschema_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68f9d87a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dagschema_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_hoofdscherm__ = __webpack_require__("pj9f");



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: "/",
    name: "5A",
    component: __WEBPACK_IMPORTED_MODULE_2__components_hoofdscherm__["a" /* default */],
    props: { klas: "5A" }
  }, {
    path: "/5A",
    name: "5A_",
    component: __WEBPACK_IMPORTED_MODULE_2__components_hoofdscherm__["a" /* default */],
    props: { klas: "5A" }
  }, {
    path: "/5B",
    name: "5B",
    component: __WEBPACK_IMPORTED_MODULE_2__components_hoofdscherm__["a" /* default */],
    props: { klas: "5B" }
  }, {
    path: "/5C",
    name: "5C",
    component: __WEBPACK_IMPORTED_MODULE_2__components_hoofdscherm__["a" /* default */],
    props: { klas: "5C" }
  }, {
    path: "/Woumen",
    name: "Woumen",
    component: __WEBPACK_IMPORTED_MODULE_2__components_hoofdscherm__["a" /* default */],
    props: { klas: "Woumen" }
  }]
}));
'filehash Co7/2yysfjzSX+m5YVkIl4t2mAo=';

/***/ }),

/***/ "ZfeE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lnn0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_dagschema_vue__ = __webpack_require__("PlO8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["klas"],
  data: function data() {
    return {
      week: 0,
      dialog: false,
      email: null,
      paswoord: null,
      actieveLes: "",
      actievePlanning: "",
      actieveTaak: ""

    };
  },

  components: {
    dagschema: __WEBPACK_IMPORTED_MODULE_0__components_dagschema_vue__["a" /* default */]
  },

  methods: {
    laadGegevens: function laadGegevens() {
      var _this = this;

      var lijst = __WEBPACK_IMPORTED_MODULE_1_firebase__["database"]().ref(this.klas).once('value').then(function (data) {
        var agendaPunten = [];
        var obj = data.val();
        for (var key in obj) {
          console.log(key);
          agendaPunten.push({
            id: key,
            datum: obj[key].datum,
            les: obj[key].les,
            taak: obj[key].taak,
            planning: obj[key].planning
          });
        }
        _this.$store.state.agendaPunten = agendaPunten;
      }).catch(function (error) {
        console.log(error);
      });
    },
    AnnuleerInvoer: function AnnuleerInvoer() {
      this.$store.state.vulAan = false;
    },
    SlaDagOp: function SlaDagOp() {
      var dag = {};
      dag.les = this.actieveLes;
      dag.taak = this.actieveTaak;
      dag.planning = this.actievePlanning;
      dag.datum = this.$store.state.actieveDag;
      if (this.$store.state.actieveDatumBestaat == false) {
        console.log("nieuwe gegevens");
        __WEBPACK_IMPORTED_MODULE_1_firebase__["database"]().ref(this.klas).push(dag).then(this.laadGegevens());
      } else {
        console.log("gegevens updaten van");
        console.log(this.$store.state.actieveKey);
        __WEBPACK_IMPORTED_MODULE_1_firebase__["database"]().ref(this.klas).child(this.$store.state.actieveKey).update(dag).then(this.laadGegevens());
      }

      this.$store.state.vulAan = false;
    },
    weekbij: function weekbij() {
      this.week += 1;
    },
    weekweg: function weekweg() {
      this.week -= 1;
    },
    toonVenster: function toonVenster() {
      this.dialog = true;
    },
    Uitloggen: function Uitloggen() {
      this.$store.state.registered = false;
    },
    Inloggen: function Inloggen() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_firebase__["auth"]().signInWithEmailAndPassword(this.email, this.paswoord).then(function (user) {
        console.log(user.uid + "is logged in");
        _this2.$store.state.registered = true;
        _this2.dialog = false;
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  watch: {
    toonPlanVenster: function toonPlanVenster(value) {
      if (value == true) {

        this.actieveTaak = this.$store.state.actieveTaak;
        this.actieveLes = this.$store.state.actieveLes;
        this.actievePlanning = this.$store.state.actievePlanning;

        console.log("toon dat venster maar!");
      }
    }
  },
  computed: {
    dag: function dag() {
      return this.$store.state.actieveDag;
    },
    dagZin: function dagZin() {
      return this.$store.state.actieveDagZin;
    },
    registered: function registered() {
      return this.$store.state.registered;
    },
    toonPlanVenster: function toonPlanVenster() {
      var rv = false;
      if (this.$store.state.registered) {
        rv = this.$store.state.vulAan;
      }

      return rv;
    },
    vulAan: function vulAan() {
      if (this.$store.state.vulAan == true) {}
    }
  },
  created: function created() {
    var _this3 = this;

    var lijst = __WEBPACK_IMPORTED_MODULE_1_firebase__["database"]().ref(this.klas).once('value').then(function (data) {
      var agendaPunten = [];
      var obj = data.val();
      for (var key in obj) {
        console.log(key);
        agendaPunten.push({
          id: key,
          datum: obj[key].datum,
          les: obj[key].les,
          taak: obj[key].taak,
          planning: obj[key].planning
        });
      }
      _this3.$store.state.agendaPunten = agendaPunten;
    }).catch(function (error) {
      console.log(error);
    });
  }
});
'filehash +RQhBWPesVpzrYDJaahYfm7Omig=';

/***/ }),

/***/ "pj9f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hoofdscherm_vue__ = __webpack_require__("lnn0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_771b98e3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hoofdscherm_vue__ = __webpack_require__("/o2/");
function injectStyle (ssrContext) {
  __webpack_require__("F0o+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hoofdscherm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_771b98e3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hoofdscherm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tLfa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "w+xg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      taak: "",
      les: "",
      planning: "",
      dagString: "",
      datumBestaat: false,
      dagObject: {}

    };
  },

  computed: {
    dag: function dag() {
      __WEBPACK_IMPORTED_MODULE_0_moment___default.a.locale("nl");
      var startdag = __WEBPACK_IMPORTED_MODULE_0_moment___default()().day(1);
      startdag.add(this.week, "week");
      var huidigeDag = startdag.add(this.extradagen, "days");
      this.dagString = huidigeDag.format("YYYYMMDD");
      return huidigeDag.format("dddd D MMMM YYYY");
    },
    agendaPunten: function agendaPunten() {
      return this.$store.getters.agendaPunten;
    },
    huidigAgendaPunt: function huidigAgendaPunt() {
      this.dagObject.taak = "";
      this.dagObject.les = "";
      this.dagObject.planning = "";
      this.dagObject.datum = this.dagString;
      this.datumBestaat = false;
      this.actieveKey = null;
      for (var i = 0; i < this.agendaPunten.length; i++) {
        console.log(this.dagString + "===?" + this.agendaPunten[i].datum);
        if (this.dagString == this.agendaPunten[i].datum) {
          console.log("er is een match!");
          this.dagObject.taak = this.agendaPunten[i].taak;
          this.dagObject.les = this.agendaPunten[i].les;
          this.dagObject.planning = this.agendaPunten[i].planning;
          this.datumBestaat = true;

          this.actieveKey = this.agendaPunten[i].id;
        }
      }
      return this.dagObject;
    }
  },
  methods: {
    toonDialoog: function toonDialoog() {
      console.log("de key is " + this.actieveKey);
      this.$store.state.actieveLes = this.dagObject.les;
      this.$store.state.actievePlanning = this.dagObject.planning;
      this.$store.state.actieveTaak = this.dagObject.taak;
      this.$store.state.actieveDag = this.dagString;
      this.$store.state.actieveDagZin = this.dag;
      this.$store.commit("setActieveDatumBestaat", this.datumBestaat);
      this.$store.state.actieveKey = this.actieveKey;
      this.$store.state.vulAan = true;
    }
  },
  props: ["week", "extradagen"]
});
"filehash 0FVtl1QiaueqjxXnila4mX/Pm+Y=";

/***/ }),

/***/ "wtEF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    registered: false,
    vulAan: false,
    hokje: "",
    actieveTaak: "",
    actieveLes: "",
    actievePlanning: "",
    actieveDag: "",
    actieveDagZin: "",
    agendaPunten: [],
    actieveDatumBestaat: false,
    actieveKey: ""

  },
  getters: {
    actieveTaak: function actieveTaak(state) {
      return state.actieveTaak;
    },
    actieveLes: function actieveLes(state) {
      return state.actieveLes;
    },
    actievePlanning: function actievePlanning(state) {
      return state.actievePlanning;
    },
    agendaPunten: function agendaPunten(state) {
      return state.agendaPunten;
    }
  },
  mutations: {
    setActieveDatumBestaat: function setActieveDatumBestaat(state, waarde) {
      console.log("Datuminstellen");
      state.actieveDatumBestaat = waarde;
    },
    setActieveKey: function setActieveKey(state, waarde) {
      state.actieveKey = waarde;
    }
  }

});
'filehash IqynW1sBd4PnKvMQnWHH8m3KDlg=';

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_hoofdscherm_vue__ = __webpack_require__("pj9f");
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  components: {
    hoofdscherm: __WEBPACK_IMPORTED_MODULE_0__components_hoofdscherm_vue__["a" /* default */]
  }
});
'filehash iX7UqmnTSr9wxwvehBmhx2D2Yhg=';

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.90ee796d1882e038a54a.js